import { useState, useRef, useContext } from "react";

import MasonryImageList from "../components/MasonryImageList";
import { useRouter } from "next/router";
import Cta from "./Cta";
import { SearchBar } from "./SearchBar";
import ItemsProvider from "./ItemsProvider";
import ItemDialog from "../components/ItemDialog";
import UserContext from "./UserContext";
import { startCase } from "lodash";

export default function MainLayout(props) {
    const { user, supabase } = useContext(UserContext);
    const router = useRouter();
    const [query, setQuery] = useState(props.query || "");
    const [selectedItem, setSelectedItem] = useState(props.initialItem || null);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const itemsProviderRef = useRef(
        new ItemsProvider(props.initialImages || [])
    );

    return (
        <div>
            <div className="relative border-b border-gray-100 dark:border-0 md:pb-2">
                <div className="container mx-auto">
                    <div className="flex-1 mx-3 sm:mx-8 md:mx-16 mt-8 sm:mt-12">
                        <h1 className="text-3xl font-bold">
                            {startCase(props.query)} Vector Images
                        </h1>
                        {props.description && (
                            <h2 className="text-gray-600 my-6 sm:text-base text-sm">
                                {props.description}&nbsp;
                                Download {props.query} SVG vector images, illustrations and clipart now
                                for free.
                            </h2>
                        )}
                    </div>
                    <div className="md:flex md:items-center sm:mt-8 justify-center sm:justify-start">
                        <div className="flex-1 mx-3 sm:mx-8 md:mx-16 mt-8">
                            <SearchBar
                                initialValue={props.query}
                                onSetQuery={(q) => {
                                    setQuery(q);
                                    console.log("set query", q);
                                    if (q && q !== router.query.q) {
                                        router.push(
                                            `/search?q=${encodeURIComponent(q)}`
                                        );
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="py-8">
                {!query && (
                    <div className="container lg:pr-32 mx-auto sm:mx-16">
                        {props.children}
                    </div>
                )}
                <div className="container lg:pr-32 mx-auto sm:mx-16">
                    <MasonryImageList
                        initialImages={props.initialImages}
                        baseUrl={props.baseUrl}
                        query={query}
                        key={query}
                        align="left"
                        initialQuery={props.initialQuery}
                        canLoadMore={props.canLoadMore}
                        itemsProvider={itemsProviderRef.current}
                        onItemClick={(item, i) => {
                            setSelectedItem(item);

                            setSelectedIndex(i);
                        }}
                    />
                </div>
                {props.haiku && (
                    <div className="container lg:px-32 mx-auto mt-16 px-2">
                        <div className="flex flex-col items-center justify-center">
                            <div className="text-center text-gray-500 text-sm leading-6 italic">
                                {props.haiku.split("\n").map((line, i) => (
                                    <div key={i}>{line}</div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
                {query && (
                    <div className="center">
                        <Cta />
                    </div>
                )}
            </div>
            {selectedItem && !props.baseUrl && (
                <ItemDialog
                    supabase={supabase}
                    item={selectedItem}
                    hasNext={() =>
                        selectedIndex !== null &&
                        itemsProviderRef.current.hasNext(selectedItem)
                    }
                    hasPrev={() =>
                        selectedIndex !== null &&
                        itemsProviderRef.current.hasPrevious(selectedItem)
                    }
                    next={() => {
                        const nextItem =
                            itemsProviderRef.current.next(selectedIndex);
                        if (nextItem) {
                            if (itemsProviderRef.current.hasNext(nextItem)) {
                                setSelectedIndex((i) => i + 1);
                                setSelectedItem(nextItem);
                            } else {
                                itemsProviderRef.current
                                    .fireOnMoreNeeded()
                                    .then(() => {
                                        setSelectedIndex((i) => i + 1);
                                        setSelectedItem(nextItem);
                                    });
                            }
                        }
                    }}
                    prev={() => {
                        const prevItem =
                            itemsProviderRef.current.previous(selectedIndex);
                        if (prevItem) {
                            setSelectedIndex((i) => i - 1);
                            setSelectedItem(prevItem);
                        }
                    }}
                    onClose={() => {
                        setSelectedItem(null);
                    }}
                />
            )}
        </div>
    );
}
